import { render, staticRenderFns } from "./preAssessmentRecord.vue?vue&type=template&id=9d20a8ea&scoped=true&"
import script from "./preAssessmentRecord.vue?vue&type=script&lang=ts&"
export * from "./preAssessmentRecord.vue?vue&type=script&lang=ts&"
import style0 from "./preAssessmentRecord.vue?vue&type=style&index=0&id=9d20a8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20a8ea",
  null
  
)

export default component.exports